module.exports=[
  "Academic Professor",
  "Compliance Officer",
  "Corporate Management",
  "Facility Manager/Supervisor/Director",
  "Information Technology",
  "Lab Manager/Supervisor/Director",
  "Medical/Clinical Specialist",
  "Medical Laboratory Scientist/Technician",
  "Nurse",
  "Pathologist",
  "Pharmacist",
  "Phlebotomist",
  "Psychiatrist",
  "Physician",
  "Purchasing Agent",
  "Research Associate",
  "Surgical",
  "Technical Consultant",
  "Other"
]
